import { ReviewItem } from '@services/reviews/models/paginated-reviews-response';
import { Quote } from '@shared/components/quote/model';

export interface ContentLayout10 {
  text: string;
}

export interface Advice {
  quote: Quote;
  rate: number;
}

/**
 * Formats an ISO-8601 date string to French month and year.
 * @example "2024-08-28T19:27:12+02:00" → "Août 2024"
 */
function formatDateToFrenchMonthYear(isoDate: string): string {
  const date = new Date(isoDate);
  const formatted = date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

/**
 * Maps a ReviewItem from the API to an Advice object used by the component.
 */
export function mapReviewItemToAdvice(review: ReviewItem): Advice {
  return {
    quote: {
      text: review.content,
      legend: formatDateToFrenchMonthYear(review.date),
    },
    rate: review.rating,
  };
}
